<script lang="ts">
    import { beforeUpdate, onMount } from "svelte";
    import { ReleaseStatus } from "../../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../../../store/stores";

    export let row;
    export let refreshCall;

    let approveModalOpen = false;
    let disapproveModalOpen = false;
    let disapproveContentMessage = "";

    const contentApproval = async (status: ReleaseStatus, message = "") => {
        approveModalOpen = false;
        disapproveModalOpen = false;
        await ApiClient.getInstance($user).contentClient.releaseContent({
            contentId: row.id,
            contentReleaseRequest: {
                releaseMessage: message,
                releaseStatus: status,
            },
        });
        refreshCall();
    };

    const disapproveContent = () => {
        contentApproval(ReleaseStatus.Denied, disapproveContentMessage);
    };

    const approveContent = () => {
        contentApproval(ReleaseStatus.Approved);
    };
</script>

<div class="element">
    <span
        class="icon has-text-success is-medium"
        on:click={() => (approveModalOpen = true)}
    >
        <i class="fas fa-thumbs-up is-medium" />
    </span>
    {#if approveModalOpen}
        <div class="modal is-active">
            <div
                class="modal-background"
                on:click={() => (approveModalOpen = false)}
            />
            <div class="modal-content">
                <div class="box">
                    <div class="content is-normal">
                        <p>Möchtest du den Content wirklich freigeben?</p>
                    </div>
                    <div class="field is-grouped">
                        <div class="control">
                            <button
                                class="button is-link"
                                on:click={approveContent}>Freigeben</button
                            >
                        </div>
                        <div class="control">
                            <button
                                class="button is-link is-light"
                                on:click={() => (approveModalOpen = false)}
                                >Abbrechen</button
                            >
                        </div>
                    </div>
                </div>
            </div>
            <button
                class="modal-close is-large"
                aria-label="close"
                on:click={() => (approveModalOpen = false)}
            />
        </div>
    {/if}
    <span
        class="icon has-text-danger is-medium"
        on:click={() => (disapproveModalOpen = true)}
    >
        <i class="fas fa-thumbs-down is-medium" />
    </span>
    {#if disapproveModalOpen}
        <div class="modal is-active">
            <div
                class="modal-background"
                on:click={() => (disapproveModalOpen = false)}
            />
            <div class="modal-content">
                <div class="box">
                    <div class="field">
                        <!-- svelte-ignore a11y-label-has-associated-control -->
                        <label class="label">Ablehnungsgrund</label>
                        <div class="control">
                            <textarea
                                class="textarea"
                                bind:value={disapproveContentMessage}
                                placeholder="Grund der Ablehnung"
                            />
                        </div>
                    </div>
                    <div class="field is-grouped">
                        <div class="control">
                            <button
                                class="button is-link"
                                on:click={disapproveContent}>Ablehnen</button
                            >
                        </div>
                        <div class="control">
                            <button
                                class="button is-link is-light"
                                on:click={() => (disapproveModalOpen = false)}
                                >Abbrechen</button
                            >
                        </div>
                    </div>
                </div>
            </div>
            <button
                class="modal-close is-large"
                aria-label="close"
                on:click={() => (disapproveModalOpen = false)}
            />
        </div>
    {/if}
</div>

<style>
    .element {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-flow: row;
        text-align: center;
        vertical-align: middle;
    }
    span {
        padding: 1.5rem;
    }
    span:hover {
        cursor: pointer;
    }
</style>
